// Mega menu overlay controller
const overlay = document.querySelector('.mega-menu-overlay');
const headerMenu = document.querySelector('header-menu');
const collectionsBar = document.querySelector('collections-bar');

if (overlay) {
  function updateHeaderMenuOverlay() {
    if (!headerMenu) return;
    const isExpanded = headerMenu.getAttribute('aria-expanded') === 'true';
    overlay.classList.toggle('is-visible', isExpanded);
    if (isExpanded) {
      overlay.classList.remove('is-collection-menu');
    }
  }

  function updateCollectionMenuOverlay() {
    if (!collectionsBar) return;
    const visibleMegaMenu = collectionsBar.querySelector('.header-collections-bar__mega-menu[data-visible="true"]');
    const isCollectionVisible = visibleMegaMenu !== null;
    overlay.classList.toggle('is-visible', isCollectionVisible);
    overlay.classList.toggle('is-collection-menu', isCollectionVisible);
  }

  if (headerMenu) {
    const headerObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'aria-expanded') {
          updateHeaderMenuOverlay();
        }
      });
    });
    headerObserver.observe(headerMenu, {
      attributes: true,
      attributeFilter: ['aria-expanded']
    });
    updateHeaderMenuOverlay();
  }

  if (collectionsBar) {
    const collectionObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'data-visible') {
          updateCollectionMenuOverlay();
        }
      });
    });

    const megaMenus = collectionsBar.querySelectorAll('.header-collections-bar__mega-menu');
    megaMenus.forEach(menu => {
      collectionObserver.observe(menu, {
        attributes: true,
        attributeFilter: ['data-visible']
      });
    });
    updateCollectionMenuOverlay();
  }

  overlay.addEventListener('click', function() {
    if (headerMenu && headerMenu.getAttribute('aria-expanded') === 'true') {
      headerMenu.style.setProperty('--submenu-height', '0px');
      headerMenu.style.setProperty('--submenu-opacity', '0');
      headerMenu.dataset.overflowExpanded = 'false';
      headerMenu.setAttribute('aria-expanded', 'false');

      const activeItems = headerMenu.querySelectorAll('[aria-expanded="true"]');
      activeItems.forEach(item => {
        item.setAttribute('aria-expanded', 'false');
        item.setAttribute('data-animating', '');
        setTimeout(() => item.removeAttribute('data-animating'), 200);
      });
    }

    if (collectionsBar) {
      const visibleMegaMenus = collectionsBar.querySelectorAll('.header-collections-bar__mega-menu[data-visible="true"]');
      visibleMegaMenus.forEach(menu => {
        menu.setAttribute('data-visible', 'false');
      });
      overlay.classList.remove('is-collection-menu');
      overlay.classList.remove('is-visible');
    }
  });
}
